import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '~/hooks/useAppSelector';
import { hideJobsInvitePopup, showJobInvitesSelectionPop } from '~/actions';
import { ConfirmPopup } from '~/commonComponents';
import {
  fireInviteRecommendationPopUpViewed,
  fireInviteRecommendationNoThanksClicked,
  fireInviteRecommendationInviteClicked,
} from '~/posthogs/events';
import AnimatedCheckCircle from './shared/AnimatedCheckCircle';

export const JobsInviteConfirmationPopup = () => {
  const dispatch = useDispatch();
  const { showConfirmation, jobIds } = useAppSelector((state) => state.multiday.jobsInvitePopup);

  useEffect(() => {
    if (showConfirmation && jobIds?.length) {
      fireInviteRecommendationPopUpViewed();
    }
  }, [showConfirmation, jobIds]);

  if (!showConfirmation || !jobIds?.length) {
    return null;
  }

  return (
    // @ts-expect-error - missing props
    <ConfirmPopup
      dataCy="shifts-posted-success-modal"
      Icon={AnimatedCheckCircle}
      title="Shifts Posted Successfully!"
      titleStyle={{ marginTop: 14 }}
      description="Would you also like to invite specific professionals to help fill these shifts faster?"
      descriptionStyle={{ marginBottom: 32 }}
      leftButtonText="No Thanks"
      leftButtonAction={() => {
        fireInviteRecommendationNoThanksClicked();
        dispatch(hideJobsInvitePopup());
      }}
      rightButtonText="Invite"
      rightButtonAction={() => {
        fireInviteRecommendationInviteClicked();
        dispatch(showJobInvitesSelectionPop());
      }}
    />
  );
};
